import script from "./MenuBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./MenuBar.vue?vue&type=script&setup=true&lang=ts"

import "./MenuBar.vue?vue&type=style&index=0&id=fedca7b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fedca7b6"]])

export default __exports__